import { Observable } from 'rxjs';
import { TermsConditionsResponse } from '../models/terms-conditions.model';

export abstract class TermsConditionsRepository {
    abstract getTermsConditions(): Observable<TermsConditionsResponse>;
}
